var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',{staticClass:"text-center text-md-left px-4 py-3",attrs:{"variant":"outline-primary"},on:{"click":_vm.previewVacancy}},[_c('span',{style:(_vm.styles[_vm.size])},[_c('i',{staticClass:"fa fa-eye"}),_vm._v(" Voorbeeld")])])}
var staticRenderFns = []

export { render, staticRenderFns }